// extracted by mini-css-extract-plugin
export default {"my_button":"custom_button_my_button__IDIGb","clicked":"custom_button_clicked__0w8l+","disabled":"custom_button_disabled__QEAmq","selected":"custom_button_selected__VcXkp"};